<template>
    <DashView>
        <div class="container-fluid pt-4 px-4">
            <div class="row g-4">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <h3 class="text-center underline">Créer Groupe&nbsp;<a href="/group-all"><i class="fa fa-file" title="Lister Groupes"></i></a></h3>
                            <div class="row" v-if="validationErrors.length>0">
                                        <div class="offset-2 col-md-8 col-sm-12">
                                            <ul v-if="validationErrors.length>0" class="list-unstyled text-center mx-auto">
                                                <li v-for="(error,key) in validationErrors" :key="key"><div class="alert alert-danger alert-md text-danger mx-auto">{{error}}</div></li>
                                            </ul>
                                        </div>
                                    </div>
                                  
                                  <div class="alert alert-success text-success text-center" v-if="success_msg">{{success_msg}}</div>    
                            <form @submit.prevent="registerGroupe" ref="fgroupe">
                                    <div class="col-sm-12 col-xs-12 col-lg-6 col-md-6 mx-auto">
                                        <div class="row">
                                            <div class="form-group">
                                                <label for="usname">Nom groupe</label>
                                                <input type="text" v-model="form.nom" title="Ajouter Nom" placeholder="Nom" required id="usname" class="form-control" autofocus="true">
                                                <p v-if="alertName" class="alert"> {{ alertName }} </p>
                                            </div>
                                        </div> 
                                        <div class="row">
                                            <div class="form-group">
                                                <label for="usadresse">Description</label>
                                                <textarea type="text"  id="usadresse" class="form-control" cols="10" required v-model="form.description" rows="3" autocomplete="off"></textarea>
                                                
                                            </div>
                                        </div>
                                        <div class="row mb-5 pb-5">
                                            <div class="pt-2">
                                                <button type="submit" class="btn btn-block btn-lg col-12" style="background:#00C853; color: #fff;">Ajouter</button>
                                            </div>
                                        </div>	
                                    </div>
                                </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </DashView>
</template>
<script>
import axios from 'axios'
  const base_url=process.env.VUE_APP_API_URL;
import DashView from "@/components/DashView.vue"
export default {
    name:"GroupRegister",
    components:{
        DashView
    },
    data(){
      return{
          success_msg:'',
          accessToken : JSON.parse(localStorage.getItem('user_zgh')).token ?? '',
          validationErrors:[],
          form :{
          nom: '',
          description: '',
        },
        alertName:'',
        regexNonVide:/^\s*$/
      }
  },
  methods:{
      registerGroupe(){
          const $data ={
              nom : this.form.nom,
              description : this.form.description
            };
          axios.post(`${base_url}/add_groupe`,$data,{
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json;charset=UTF-8',
                    Authorization:`Bearer ${this.accessToken}`
                }
            })
          .then((response)=>{
              console.log(response.data);
              if(response?.status==201){
                  this.success_msg = `Groupe ajouté avec success!`;
                  let self = this;
                  setTimeout(function() {
                          self.$router.push('/group-all');
                      //   location.reload();
                      },1000);
              }
              else{
                console.log('Un erreur est survenu');
              }
          })
          .catch((error)=>{
              if (error?.response?.status === 401) {
                        this.displayValidationErrors(error.response.data.errors);                       
                } 
                else if(error?.response?.status === 403){
                    console.log('NO access');
                    $('#openModalNoAccess').trigger('click');
                }
                else {
                    // Gérer d'autres erreurs ici
                    console.log('Autre erreur:', error);
                }
          })
      },
      displayValidationErrors(errors) {
        // Remplacer les erreurs actuelles par les nouvelles
        this.validationErrors = [];

        // Parcourir les erreurs et les ajouter au tableau
        Object.keys(errors).forEach(field => {
            this.validationErrors.push(errors[field][0]);
        });

        // Définir un délai de 2 secondes avant de vider les erreurs
        setTimeout(() => {
            this.clearValidationErrors();
        }, 2000);

    },
    clearValidationErrors() {
        this.validationErrors = [];
    },
  },
}
</script>
<style lang="">
    
</style>